import { render, staticRenderFns } from "./hour.vue?vue&type=template&id=0a37ab4e&scoped=true&"
import script from "./hour.vue?vue&type=script&lang=js&"
export * from "./hour.vue?vue&type=script&lang=js&"
import style0 from "./hour.vue?vue&type=style&index=0&id=0a37ab4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37ab4e",
  null
  
)

export default component.exports